import React from 'react';
import './FooterSection.css';
import Button from '../Button/Button';
import logo from '../../Assets/logo.png';
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaPhoneAlt } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
        <div className="footer-cta-banner">
          <div className="cta-content">
            <h2>Ready to Insulate Your <br /> Project?</h2>
            <p>Partner with us for reliable, high-performance insulation solutions tailored to your requirements.</p>
            {/* Added anchor to contact section */}
            <a href="#contact">
              <Button text="Contact Our Experts" variant="primary" size="md" />
            </a>
          </div>
        </div>

        <div className="footer-main">
          <div className="footer-container">
            <div className="footer-col brand-col">
              <img src={logo} alt="ANNAI INSULATIONS" className="footer-logo" />
              <p className="footer-tagline">Let's build smarter insulation solutions.</p>
              <div className="social-links">
                {/* Fixed warnings: Replace # with actual links or "https://..." */}
                <a href="https://instagram.com" target="_blank" rel="noreferrer"><FaInstagram /></a>
                <a href="https://facebook.com" target="_blank" rel="noreferrer"><FaFacebookF /></a>
                <a href="https://linkedin.com" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
              </div>
            </div>

            <div className="footer-col links-col">
              <ul>
                {/* Ensure these match the IDs in App.js */}
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About Us</a></li>
                <li><a href="#services">Services</a></li>
                <li><a href="#projects">Projects</a></li>
                <li><a href="#contact">Contact Us</a></li>
              </ul>
            </div>

            <div className="footer-col contact-col">
              <h4>Address:</h4>
              <address>
                7/18, Kamatchi Nagar 1st Street, Ayyappanthangal<br />
                Chennai, Tamil Nadu - 600056, India
              </address>
              
              <button className="download-btn">
                Download Brochure <span>→</span>
              </button>

              <div className="footer-phone">
                <FaPhoneAlt className="phone-icon" />
                <a href="tel:+918047682166">+91 80476 82166</a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-container">
            <p>© {currentYear} Annai Insulations. All rights reserved. 
               Developed by <a href="https://ascentbrandworks.com" target="_blank" rel="noreferrer">ASCENT BRANDWORKS</a>.
            </p>
          </div>
        </div>
    </footer>
  );
};

export default Footer;